import { HiChevronRight, HiOutlineFolder } from "react-icons/hi";

/** A folder to open, wearing its own cover — the same card the student browses with. */
export function TreeProjectRow({
  name,
  imageUrl,
  caption,
  onPress,
}: {
  name: string;
  imageUrl: string | null | undefined;
  caption: string;
  onPress: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onPress}
      className="flex w-full items-center gap-3 border-gray-100 border-b py-2.5 text-left hover:bg-gray-50"
    >
      {/* A folder with no cover keeps the same footprint, so a list of them stays even. */}
      <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-[14px] bg-[#F4F4FB]">
        {imageUrl ? (
          <img src={imageUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <HiOutlineFolder className="h-6 w-6 text-[#C7C7E6]" />
        )}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate font-kumbh font-bold text-[16px] text-app-ink">{name}</span>
        <span className="block text-[11px] text-app-muted">{caption}</span>
      </span>
      <HiChevronRight className="h-5 w-5 shrink-0 text-app-muted" />
    </button>
  );
}
